import Cross from "../../../assets/icon/NewsIcons/MainAdmin/NewsCross"
import React, { useState, useEffect, useRef } from "react";
import { axiosReq, axiosReq2, axiosReqCustom } from "../../../commons/axiosReq";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import { apiUrlWordCloudImageSar } from "../../../commons/inFormTypes";
import PhotoUpload from "../MainComponents/FileUpload"
import ClipLoader from "react-spinners/ClipLoader"

const AddModalWordCloud = ({ setShowModal, title, buttonName, setRecheck, reCheck, data, type }) => {
    let navigate = useNavigate();
    const [snipper, setSnipper] = useState(false);
    const [showErrorModalStep1,
        setShowErrorModalStep1] = useState(false);
    const [error, setEroor] = useState();
    const [dataimage, setDataImage] = useState();
    const [files, setFiles] = useState();
    const [selectedOptions, setSelectedOptions] = useState([]);
    const handleSelectChange = (selected) => {
        setSelectedOptions(selected || []);
    };
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            borderColor: state.isFocused ? "#f1f5ff" : "#f1f5ff",
            borderRadius: 5, // رنگ بوردر در حالت فوکوس و غیرفوکوس
            "&:hover": {
                borderColor: "#f1f5ff", // رنگ بوردر هنگام هاور
            },
            boxShadow: state.isFocused ? "none" : "none", // سایه در حالت فوکوس
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: "#e8eeff", // رنگ پس‌زمینه تگ‌های انتخاب شده
            color: "#fff",
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: "#000", // رنگ متن تگ‌های انتخاب شده
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: "#000",
            "&:hover": {
                backgroundColor: "#E64A19", // رنگ پس‌زمینه دکمه حذف هنگام هاور
                color: "white",
            },
        }),
    };
    const [allValues, setAllValues] = useState({
        Name: '',


    });
    const [allValuesError, setAllValuesError] = useState({
        Name: false,


    });
    const blurHandler = e => {
        if (e.target) {
            if (e.target.value == "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: true })
            }


        }

    }
    const changeHandler = e => {
        if (e.target) {
            if (e.target.value != "") {

                setAllValuesError({ ...allValuesError, [e.target.name]: false })
            }
            else {
                setAllValuesError({ ...allValuesError, [e.target.name]: true })

            }
            // setAllValuesError({ ...allValuesError, [""]: false })


            setAllValues({ ...allValues, [e.target.name]: e.target.value })
        }
    }
    const handleKeyDown = (e) => {
        if (e.code === "Enter") {
            addAdmin();
        }
    };

    const downloadImage = (base64Data, filename = 'generated-image.png') => {
        const link = document.createElement('a');
        link.href = base64Data;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const addAdmin = async () => {

        setSnipper(true)



        var res = allFull(allValues)
        console.log(22)
        console.log(res)
        console.log(selectedOptions)
        if (res && selectedOptions?.value) {
            try {
                console.log(33)


                const dataUser = await axiosReqCustom(apiUrlWordCloudImageSar + "generate-wordcloud-from-text", "post", {
                    text: allValues?.Name,
                    ner_type: selectedOptions.value

                });
                console.log(dataUser)
                console.log(dataUser?.data?.image)
                if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {

                    if (dataUser?.data?.image) {

                        setDataImage(dataUser?.data?.image);
                    } else {
                        alert("داده ای دریافت نشد")
                    }
                    setSnipper(false);

                    // alert("موفقیت آمیز");
                }


                else {
                    console.log(allValuesError)
                    setEroor(dataUser?.data?.detail || "خطا در پردازش داده ها")
                    setSnipper(false);

                    setShowErrorModalStep1(true);
                }
            } catch (error) {
                alert(error.detail || "خطا در برقراری ارتباط با سرور");
            }
        }

        else {
            setEroor("لطفا موارد خواسته شده را وارد نمایید")

            console.log(allValuesError)
            setShowErrorModalStep1(true);

            setSnipper(false);

        }

    }

    const editAdmin = async () => {
        setSnipper(true);

        try {
            if (!selectedOptions.value) {
                setEroor("لطفا ابتدا موجودیت را انتخاب کنید");
                setShowErrorModalStep1(true);
                setSnipper(false);

                return;
            }
            if (!files) {
                setEroor("لطفا ابتدا یک فایل انتخاب کنید");
                setShowErrorModalStep1(true);
                setSnipper(false);

                return;
            }

            const formData = new FormData();
            console.log(99)
            console.log(files)
            console.log(files?.name)
            // "file" must match your curl field name: -F 'file=@test.txt;type=text/plain'
            formData.append("file", files, files?.name);
            formData.append("ner_type", selectedOptions.value);
            console.log(66)
            console.log(formData)
            const { data, status } = await axios.post(
                apiUrlWordCloudImageSar + "generate-wordcloud",
                formData,
                {
                    headers: {
                        Authorization: `Bearer c2dffe2aa00a3f8b7d854279f4aaa1ff`,
                        // Let the browser set the multipart boundary
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (status >= 200 && status < 300) {
                if (data?.image) {

                    setDataImage(data?.image);
                } else {
                    alert("داده ای دریافت نشد")
                }
                setSnipper(false);

            } else {
                setSnipper(false);

                setEroor(data?.detail || "خطا در پردازش داده ها")
                setShowErrorModalStep1(true);
            }
        } catch (err) {
            setSnipper(false);
            console.log(444)
            console.log(err)
            setEroor(
                err?.response?.data?.detail||
                err?.response?.data?.detail[0].msg ||
                err?.message ||
                "خطا در برقراری ارتباط با سرور"
            );
            setShowErrorModalStep1(true);
        } finally {
            setSnipper(false);
        }
    };


    // const editAdmin = async () => {
    //     setSnipper(true)


    //     const formData = new FormData();
    //     formData.append("file", files);

    //     const dataUser = await axios.post(apiUrlWordCloudImageSar + "generate-wordcloud", {
    //         formData,


    //     }, {
    //         headers: {
    //             "Content-Type": "multipart/form-data",
    //             Accept: "application/json",
    //             // "Authorization": "Bearer " + props.token,
    //         }
    //     });
    //     console.log(dataUser)
    //     console.log(dataUser?.data?.image)
    //     if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {

    //         // setRecheck(!reCheck)
    //         // setShowModal(false)
    //         setDataImage(dataUser?.data?.image)
    //         // alert("موفقیت آمیز");
    //     }


    //     else {
    //         console.log(allValuesError)
    //         setEroor(dataUser?.data)

    //         setShowErrorModalStep1(true);
    //     }


    // }
    const allFull = (obj) => {
        const updatedState = {};
        var result = true;
        for (var o in obj) {
            if (obj[o] == "" && o != "IsAdmin") {
                updatedState[o] = true;


                setAllValuesError({ ...allValuesError, ...updatedState })
                result = false;
            }
            // else if(obj[o] == "" && o=="SubCategoryId" && obj["CategoryId"] != ""){
            //     updatedState[o] = true;


            //     setAllValuesError({ ...allValuesError, ...updatedState })
            //     result = false;
            // }

        }
        console.log(allValuesError)
        return result
    }

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }
    return (
        <>
            <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
                <div className="relative w-[60%] my-5 mx-auto ">

                    <div className="border-0 rounded-[20px] p-[25px] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
                            <p className="text-[15px] font-IRANYekanBold text-mainColor2">{title}</p>
                            <button onClick={() => setShowModal(false)}><Cross /></button>
                        </div>

                        <Select
                            options={[
                                // { value: null, label: "کل موجودیتها" }, 
                                { value: "per", label: "شخص" }, { value: "org", label: "سازمان" }, { value: "loc", label: "مکان" },]}
                            // isMulti
                            value={selectedOptions}
                            onChange={handleSelectChange}
                            placeholder="موجودیت ‌ها را انتخاب کنید"
                            styles={customStyles}
                            className="text-[12px] w-[50%] mt-1 font-IRANYekanNormal focus:outline-lightGray border-[1px] border-borderGray rounded-[5px]"
                        />
                        {dataimage ?
                            <img
                                src={dataimage}
                                className="image-message cursor-pointer"
                                alt="Base64"
                                style={{ width: "400px", height: "auto", margin: "20px" }}
                                onClick={() => downloadImage(dataimage)}
                            />
                            :
                            null}
                        {
                            type == "name" ?
                                <div className="grid grid-cols-3 gap-2 w-full mt-[23px] mb-[43px]">
                                    <div className="col-span-3 mb-[10px] flex flex-col">
                                        <span className="text-[15px] font-IRANYekanBold mb-1">متن</span>
                                        <input
                                            onChange={changeHandler}
                                            onBlur={blurHandler}
                                            name="Name"
                                            placeholder="متن را اینجا بنویسید"
                                            value={allValues?.Name}
                                            onInput={maxLengthCheck}
                                            maxLength={10000}
                                            multiple={true}

                                            className="h-[100px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] w-full rounded-[5px] placeholder-lightGray" type="text" />

                                    </div>
                                    {/* <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">نام خانوادگی</span>
                                <input
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text" placeholder="نام خانوادگی را اینجا بنویسید"
                                    onBlur={blurHandler}
                                    name="Family"
                                    onChange={changeHandler}
                                    value={allValues?.Family}
                                    onInput={maxLengthCheck}
                                    onKeyPress={(event) => {
                                        if (/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                        if (/[۱-۹]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    maxLength={100} />
                                     {
                                    allValuesError.Family ?
                                        <span class="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا نام خانوادگی را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div> */}





                                </div>
                                :
                                <div className="grid grid-cols-2 gap-2 w-full mt-[23px] mb-[43px]">
                                    <div className="col-span-1 mb-[10px] flex flex-col">
                                        <span className="text-[15px] font-IRANYekanBold mb-1">فایل</span>
                                        <PhotoUpload
                                            setFile={setFiles}
                                        />
                                    </div>






                                </div>
                        }
                        <div className="flex justify-center">
                            <button onClick={() => setShowModal(false)}><p className="text-[15px] font-IRANYekanBold ml-[23px]">بستن</p></button>
                            <button onClick={() => type == "name" ? addAdmin() : editAdmin()} className="h-[40px] w-[107px] bg-Orange2 rounded-[10px]">
                                {
                                    snipper ?
                                        <div className="flex justify-center items-center">

                                            <ClipLoader
                                                color={"#000000"}
                                                loading={snipper}
                                                // cssOverride={override}
                                                size={30}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                            />
                                        </div>
                                        :
                                        <p className="text-[15px] text-white font-IRANYekanBold">{buttonName}</p>}                            </button>
                        </div>
                    </div>
                </div>
                {showErrorModalStep1 ?
                    <>
                        <div
                            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                        >
                            <div className="relative w-[30%] lg:w-[50%] sm:w-[95%] my-5 mx-auto max-w-3xl">

                                <div className="border-0 rounded-lg p-2 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">

                                    <div className="flex items-start justify-between p-4 border-b border-solid border-b-midGray rounded-t">
                                        <span className="text-base font-bold   text-red">
                                            درخواست اشتباه !
                                        </span>

                                    </div>

                                    <div className="relative px-4 py-1 flex-auto">
                                        <p className="my-4 text-black text-sm   leading-relaxed">
                                            {error}
                                        </p>
                                    </div>

                                    <div className="flex  items-center  justify-end border-solid border-slate-200 rounded-b">
                                        <Link

                                            className="text-white  mx-4 mb-2  rounded-md shadow-blueShadow  bg-Orange2 font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setShowErrorModalStep1(false)}
                                        >
                                            فهمیدم
                                        </Link>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>

                    </>
                    : null
                }
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    )
}

export default AddModalWordCloud;